module.exports = __webpack_public_path__ + "img/promo-image.407f492.png";